module.exports = __webpack_public_path__ + "img/search-age-icon.png";